<template>
  <div>
    <el-form :inline="true"  class="demo-form-inline" size="small">
      <el-form-item label="变动类型">
        <el-select v-model="searchParams.type" clearable placeholder="变动类型" style="width: 150px" @change="handleSearch()">
          <el-option v-for="(item,index) in typeConfig" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleSearch">刷新</el-button>
      </el-form-item>
    </el-form>
    <div class="table_wrap" >
      <el-table :data="tableData" style="width: 100%" v-loading="loading" >
        <el-table-column label="店铺名称" align="center">
          <template #default="{row}">
            <div>{{row?.merchant_shop?.shop_name??''}}</div>
          </template>
        </el-table-column>
        <el-table-column label="店铺类型" align="center">
          <template #default="{row}">
            <el-tag type="danger" effect="plain" size="mini" v-if="row?.merchant_shop?.shop_type==1">抖店</el-tag>
            <el-tag type="success" effect="plain" size="mini" v-if="row?.merchant_shop?.shop_type==7">微信小店</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="变动类型" prop="type_name" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 'recharge'" type="success" size="mini">充值</el-tag>
            <el-tag v-else-if="scope.row.type === 'use'" type="danger" size="mini">消耗</el-tag>
            <el-tag v-else-if="scope.row.type === 'return'" type="warning" size="mini">退还</el-tag>
            <el-tag v-else-if="scope.row.type === 'gift'" type="info" size="mini">赠送</el-tag>
            <el-tag v-else-if="scope.row.type === 'recover'" type="danger" size="mini">扣除</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="变动算力值" prop="change_amount" align="center"> </el-table-column>
        <el-table-column label="算力值余额" prop="balance_after" align="center" > </el-table-column>
        <el-table-column label="创建时间" prop="created_at" align="center" min-width="100">
          <template #default="{row}">
            <div>{{ row.created_at || '' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" align="center"> </el-table-column>
      </el-table>
    </div>
    <div class="turn_page" >
      <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100,  200, 300, 400]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listTotal">
      </el-pagination>
    </div>
  </div>
</template>
<script >
import {mapActions} from "vuex";

export default {
  name: "computPowerList",
  data() {
    return {
      searchParams:{type:''},
      loading: false,
      tableData: [],
      page: 1,
      page_size: 10,
      listTotal: 0,
      typeConfig: [
        {value: 'recharge',label: '充值'},
        {value: 'use',label: '消耗'},
        {value: 'return',label: '退还'},
        {value: 'gift',label: '赠送'},
        {value: 'recover',label: '扣除'}
      ]
    }
  },
  methods:{
    ...mapActions({
      gerComputingPowerFinanceList:'ucenter/gerComputingPowerFinanceList'
    }),
    init(){
      this.searchParams={type: ''}
      this.page=1
      this.getTableData()
    },
    getTableData() {
      const  params={
        page: this.page,
        page_size: this.page_size,
        ...this.searchParams
      }
      this.loading=true
      this.gerComputingPowerFinanceList({
        data: params, success: (res) => {
          this.loading=false
          if (res.code === 200) {
            this.tableData = res.data.list
            this.listTotal = res.data.total
          } else {
            this.$message({message: res.msg || res.message, type: 'error',});
          }
        }
      })
    },
    handleSearch(){
      this.page = 1
      this.getTableData()
    },
    currentChange(val) {
      this.page = val
      this.getTableData()
    },
    sizeChange( val){
      this.page_size = val
      this.page = 1
      this.getTableData()
    },
  }
}
</script>


<style scoped>
.turn_page {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
</style>
